import { ScrollView } from 'react-native'
import { SafeAreaView } from 'react-native-safe-area-context'

interface ScreenContainerProps {
  children: React.ReactNode
  scroll?: boolean
  className?: string
}

export function ScreenContainer({ children, scroll = false, className = '' }: ScreenContainerProps) {
  if (scroll) {
    return (
      <SafeAreaView className={`flex-1 bg-canvas-primary ${className}`}>
        <ScrollView className="flex-1" contentContainerClassName="grow">
          {children}
        </ScrollView>
      </SafeAreaView>
    )
  }

  return (
    <SafeAreaView className={`flex-1 bg-canvas-primary ${className}`}>
      {children}
    </SafeAreaView>
  )
}